import { useCallback, useEffect, useState } from 'react';

export const useThemeLoaded = (isSSR: boolean) => {
	const [isNotLoaded, setIsNotLoaded] = useState(true);
	const setThemeLoaded = useCallback(() => setIsNotLoaded(isSSR), [isSSR]);
	const themeTimeout = setTimeout(setThemeLoaded, 2500);
	const onThemeLoaded = useCallback(() => {
		clearTimeout(themeTimeout);
		setThemeLoaded();
	}, [themeTimeout, setThemeLoaded]);

	useEffect(() => {
		return () => clearTimeout(themeTimeout);
	}, [themeTimeout]);

	return {
		isNotLoaded,
		onThemeLoaded,
	};
};
